export default "__VITE_ASSET__DwhXBcGF__"